import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';

import { CellPickerModule } from '../cell-picker/cell-picker.module';
import { CellsPickerComponent } from './cells-picker.component';

@NgModule({
    imports: [
        CellPickerModule,
        CommonModule,
        MatChipsModule,
        MatIconModule,
        ReactiveFormsModule
    ],
    declarations: [
        CellsPickerComponent
    ],
    exports: [
        CellsPickerComponent
    ]
})
export class CellsPickerModule {
}
